import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { Button } from "@curves/ui-base";
import { EmployeeSelect } from "@icoach/components/";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import useCyclePurchaseApi from "@apis/useCyclePurchaseApi";

const CycleOrderQuitDialog = ({ className, open, sourceData, onClose, refresh }) => {
	const { cycleOrderID } = sourceData || {};
	const { getCyclePurchaseOptionsApi, deleteCyclePurchaseOrderApi } = useCyclePurchaseApi();
	const [resource, setResource] = useState({});

	const employeeRef = useRef(null);

	const doDeleteCyclePurchaseOptionsApi = async () => {
		let res = await getCyclePurchaseOptionsApi();
		if (res) {
			setResource(res);
		}
	};

	let doCyclePurchaseOrderApi = async (cycleOrderID, employeeID) => {
		const res = await deleteCyclePurchaseOrderApi(cycleOrderID, { employeeID });
		if (res) {
			refresh && refresh();
			onClose();
		}
	};

	const handleSubmit = () => {
		let isError = employeeRef.current && employeeRef.current.isError && employeeRef.current.isError();
		if (!isError) {
			const employeeID = employeeRef.current && employeeRef.current.getResult && employeeRef.current.getResult();
			doCyclePurchaseOrderApi(cycleOrderID, employeeID);
		}
	};

	useEffect(
		() => {
			if (open) {
				doDeleteCyclePurchaseOptionsApi();
			}
		},
		// eslint-disable-next-line
		[open],
	);

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-40rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>刪除健康產品循環訂購單</GradientColorHeader>
			<DialogContent>
				<Grid spacing={3} container>
					<Grid xs={12} item>
						<EmployeeSelect label="擔當" ref={employeeRef} options={resource?.coachOptions || []} fullWidth required />
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={handleSubmit}>
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default CycleOrderQuitDialog;
